module.exports = __webpack_public_path__ + "static/03-14ab7960dce4805ea8c2d199f61cd962.png";